import { TypographyOptions } from "@mui/material/styles/createTypography";

declare module "@mui/material/styles" {
  interface TypographyVariants {
    body3: React.CSSProperties;
    body4: React.CSSProperties;
    body5: React.CSSProperties;
    body6: React.CSSProperties;
    body7: React.CSSProperties;
    body8: React.CSSProperties;
    body9: React.CSSProperties;
    body10: React.CSSProperties;
  }
  interface TypographyVariantsOptions {
    body3: React.CSSProperties;
    body4: React.CSSProperties;
    body5: React.CSSProperties;
    body6: React.CSSProperties;
    body7: React.CSSProperties;
    body8: React.CSSProperties;
    body9: React.CSSProperties;
    body10: React.CSSProperties;
  }
}
declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    body3: true;
    body4: true;
    body5: true;
    body6: true;
    body7: true;
    body8: true;
    body9: true;
    body10: true;
  }
}

export const typography: TypographyOptions = {
  fontFamily: "YeBakh",
  fontWeightBold: "normal",
  h1: {
    fontSize: 32,
    fontFamily: "YeBakh-Bold",
  },
  h2: {
    fontSize: 26,
    fontFamily: "YeBakh-Bold",
  },
  h3: {
    fontSize: 24,
    fontFamily: "YeBakh-Bold",
  },
  h4: {
    fontSize: 22,
    fontFamily: "YeBakh-Bold ",
  },
  h5: {
    fontSize: 18,
    fontFamily: "YeBakh-Bold",
    lineHeight: "22px",
  },
  h6: {
    fontSize: 16,
    fontFamily: "YeBakh-Bold",
    lineHeight: "22px",
  },
  body1: {
    fontSize: 14,
    fontFamily: "YeBakh-Bold",
  },
  body2: {
    fontSize: 12,
    fontFamily: "YeBakh-Bold", //700
  },
  body3: {
    fontSize: 10,
    fontFamily: "YeBakh-Bold",
  },
  body4: {
    fontSize: 20,
    fontFamily: "YeBakh-SemiBold", //600
  },
  body5: {
    fontSize: 14,
    fontFamily: "YeBakh-SemiBold",
  },
  body6: {
    fontSize: 12,
    fontFamily: "YeBakh-SemiBold",
  },
  body7: {
    fontSize: 10,
    fontFamily: "YeBakh-SemiBold",
  },
  body8: {
    fontSize: 8,
    fontFamily: "YeBakh-SemiBold",
  },
  body9: {
    fontSize: 12,
    fontFamily: "YeBakh",
  },
  body10: {
    fontSize: 8,
    fontFamily: "YeBakh-Bold",
  },
};
